<script>
import { mapState, mapActions } from 'vuex';

export default {
  template: '#timeline',
  computed: {
    ...mapState(['general']),
    ...mapActions(['layers/fetchLayersFromPhase'])
  },
  data() {
    return {
      isDown: false,
      scrollLeft: 0,
      startX: 0,
      timelineClass: 'timeline',
      reachedRight: false,
      reachedLeft: true
    };
  },
  mounted: () => {
    let timelineEl = document.querySelector('.timeline');
    timelineEl.scrollLeft = 0;
  },
  methods: {
    tlMouseDown(event) {
      let timelineEl = document.querySelector('.' + this.timelineClass);
      this.isDown = true;

      this.startX = event.pageX - timelineEl.offsetLeft;
      this.scrollLeft = timelineEl.scrollLeft;
    },
    tlMouseLeave() {
      this.isDown = false;
      let timelineEl = document.querySelector('.' + this.timelineClass);
      this.checkBoundaries(timelineEl);
    },
    tlMouseUp() {
      this.isDown = false;
      let timelineEl = document.querySelector('.' + this.timelineClass);
      this.checkBoundaries(timelineEl);
    },
    tlMouseMove(event) {
      if (!this.isDown) return;
      event.preventDefault();
      let timelineEl = document.querySelector('.' + this.timelineClass);
      const x = event.pageX - timelineEl.offsetLeft;
      const walk = (x - this.startX) * 3;
      timelineEl.scrollLeft = this.scrollLeft - walk;

      this.checkBoundaries(timelineEl);
    },
    doScrollRight() {
      let timelineEl = document.querySelector('.' + this.timelineClass);
      timelineEl.scrollLeft += 70;

      this.checkBoundaries(timelineEl);
    },
    doScrollLeft() {
      let timelineEl = document.querySelector('.' + this.timelineClass);
      timelineEl.scrollLeft -= 70;

      this.checkBoundaries(timelineEl);
    },
    checkBoundaries(timelineEl) {
      if (
        timelineEl.scrollWidth -
          timelineEl.clientWidth -
          timelineEl.scrollLeft <
        15
      ) {
        this.reachedRight = true;
      } else {
        this.reachedRight = false;
      }

      if (timelineEl.scrollLeft < 15) {
        this.reachedLeft = true;
      } else {
        this.reachedLeft = false;
      }
    },
    changePhase(phaseId) {
      let obj = {
        ...this.$route.params
      };
      obj['phase'] = phaseId;
      this.$router.replace({ name: 'base', params: obj }).catch((err) => {});

      this.$store.dispatch('general/setPhase', phaseId);
      this.$store.dispatch('layers/fetchLayersFromPhase', [phaseId]);
    }
  }
};
</script>

<style scoped>
.timeline__title,
.timeline__line__num {
  cursor: pointer;
}
</style>
